var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReview = function SvgReview(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.667 4.667H9.333c-2.566 0-4.643 2.1-4.643 4.666l-.023 42L14 42h32.667a4.68 4.68 0 0 0 4.666-4.667v-28a4.68 4.68 0 0 0-4.666-4.666m0 32.666H12.063l-1.376 1.377-1.354 1.353V9.333h37.334zM24.5 32.667H42V28H29.167zm9.007-13.697a1.155 1.155 0 0 0 0-1.657l-4.13-4.13a1.155 1.155 0 0 0-1.657 0L14 26.903v5.764h5.763z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/review.8b215be21490c7e4e3c708f57ebf3193.svg";